import { render, staticRenderFns } from "./AppointmentDetailsComponent.vue?vue&type=template&id=d19f5bde&scoped=true&"
import script from "./AppointmentDetailsComponent.vue?vue&type=script&lang=ts&"
export * from "./AppointmentDetailsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentDetailsComponent.vue?vue&type=style&index=0&id=d19f5bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19f5bde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VChip,VCol,VContainer,VDivider,VIcon,VRow})
